import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'wsm-error-boundary';
import {
	WIDGET_LOADED,
	WIDGET_LOADING,
	WIDGET_HIDDEN
} from '../actions/widgetStates';
import Loaded from './views/Loaded';
import NotLoaded from './views/NotLoaded';
import Hidden from './views/Hidden';
import ErrorController from '../containers/ErrorController';

class WidgetDisplay extends React.Component {
	render() {
		let currentView;

		switch (this.props.widgetState.state) {
			case WIDGET_HIDDEN:
				currentView = <Hidden />;
				break;
			case WIDGET_LOADED:
				currentView = <Loaded />;
				break;
			case WIDGET_LOADING:
				currentView = <NotLoaded />;
				break;
			default:
				currentView = <ErrorController />;
		}

		return (
			<ErrorBoundary newRelicPageAction="WS PAYMENT CALCULATOR ERROR BOUNDARY">
				<div className="viewContainer">{currentView}</div>
			</ErrorBoundary>
		);
	}
}

WidgetDisplay.propTypes = {
	widgetState: PropTypes.shape({
		state: PropTypes.string,
		nextState: PropTypes.arrayOf(PropTypes.string)
	}).isRequired
};

export default WidgetDisplay;
